<template>
  <div>
    <h3 style="color:#143150"><b>{{start}}. Web Hacking Attack Detection & Blocking (WEBCastle)</b></h3><br>
    <b-row style="padding-left:25px;">
      <b-col>
        <h4><b>{{start}}.1 Summary</b></h4>
        <b-row style="padding-left:25px;">
          <b-col><br>
            <h5><b>{{start}}.1.1. General Information</b></h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">Username</th>
                  <th style="background-Color:#3D63BA; text-align: center; background-Color:#f0f3f5;">{{auth.profile.username}}</th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">period</th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{from}} ~ {{to}}</th>
                </tr>
              </tbody>
            </table>
            <h5><b>{{start}}.1.2. WEBCastle Status</b></h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">Status</th>
                  <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Count</th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Contracted</th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{ (castle_summary && castle_summary.agent_list ? castle_summary.agent_list.length : 0) | number }}</th>
                </tr>
              </tbody>
            </table>
            <h5><b>{{start}}.1.3. Total number of security Events</b></h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">Events</th>
                  <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Count</th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Detected</th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{ (castle_summary && castle_summary.total_detect ? castle_summary.total_detect : 0) | number }}</th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">Blocked</th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{ (castle_summary && castle_summary.total_block ? castle_summary.total_block : 0) | number }}</th>
                </tr>
              </tbody>
            </table>
            <h5><b>{{start}}.1.4. Web Server & WEBCastle Status</b></h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th class="table-f1" style="width:40%" colspan="4">Server</th>
                </tr>
                <tr>
                  <th class="table-f1">Name</th>
                  <th class="table-f1">IP</th>
                  <th class="table-f1">Status</th>
                  <th class="table-f1">Deleted</th>
                </tr>
                <tr v-for="WC_S_2_1_4 in castle_summary.agent_list" :key="WC_S_2_1_4.id">
                  <th style="border:1px solid; text-align: center;">{{WC_S_2_1_4.name || 'N/A'}}</th>
                  <th style="border:1px solid; text-align: center;">{{WC_S_2_1_4.host || 'N/A'}}</th>
                  <th style="border:1px solid; text-align: center;">
                    <b-badge :variant="WC_S_2_1_4.is_del ? '' : 'success'">{{WC_S_2_1_4.is_del ? 'Off' : 'On'}}</b-badge>
                  </th>
                  <th style="border:1px solid; text-align: center;">
                    <span>{{WC_S_2_1_4.is_del ? (moment(WC_S_2_1_4.deleted_at).format('YYYY-MM-DD') || '-') : '-'}}</span>
                  </th>
                </tr>
                <tr v-if="castle_summary.agent_list < 1">
                  <td style="border:1px solid; text-align: center;">N/A</td>
                  <td style="border:1px solid; text-align: center;">N/A</td>
                  <td style="border:1px solid; text-align: center;">N/A</td>
                  <td style="border:1px solid; text-align: center;">N/A</td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>

        <h4><b>{{start}}.2 Monitoring Status</b></h4>
        <b-row style="padding-left:25px;">
          <b-col><br>
          <h5><b>{{start}}.2.1. Daily detection and blocking Events by Total</b></h5>
          <b-row style="padding-left:25px;">
            <b-col>
              <h5><b>{{start}}.2.1.1 Daily detection (Total)</b></h5>
              <line-chart :chartData="WebCastle_Daily_Detecting" > </line-chart>
              <hr>
              <h5><b>{{start}}.2.1.2 Daily blocking (Total)</b></h5>
              <line-chart :chartData="WebCastle_Daily_Blocking" > </line-chart>
            </b-col>
          </b-row>
          <hr>
          <h5><b>{{start}}.2.2. Daily detection and blocking Events by individual</b></h5>
          <b-row style="padding-left:25px;">
            <!-- 서버별 -->
            <b-col sm="12" v-for="(server, index) in WebCastle_Daily_log_by_server" :key="index + '_daily_server'" v-if="show_agent">
              <h5 class="mt-2">
                <b>
                  2.2.2.{{index+1}}. Daily Detecting & Blocking Server ({{server.name}}) {{server.deleted_at ? `- Deleted at ${server.deleted_at}` : ''}}
                </b>
              </h5>
              <line-chart :chartData="server"></line-chart>
            </b-col>
            <hr>
            <!-- 아무 데이터 없을 경우에 대해 비어 있는 양식을 보여 줘야 함 -->
            <b-col sm="12" v-if="WebCastle_Daily_log_by_server.length < 1 && show_agent">
              <h5 class="mt-2">
                <b>
                  {{start}}.2.2.{{WebCastle_Daily_log_by_server.length + 1}} Daily Detecting & Blocking Domain
                </b>
              </h5>
              <line-chart :chartData="DEFAULT_CHART_DATA"></line-chart>
            </b-col>
            <hr>
            <!-- 도메인별 -->
            <b-col sm="12" v-for="(domain, index) in WebCastle_Daily_log_by_domain" :key="index + '_daily_domain'">
              <h5 class="mt-2" v-if="domain && domain.labels.length > 0">
                <b>
                  2.2.2.{{show_agent ? (index + (WebCastle_Daily_log_by_server ?  WebCastle_Daily_log_by_server.length : 1) + 1) : 1 }}. Daily Detecting & Blocking Domain <small>({{domain.name}}) {{domain.deleted_at ? `- Deleted at ${domain.deleted_at}` : ''}}</small>
                </b>
              </h5>
              <line-chart :chartData="domain"></line-chart>
              <!-- <line-chart v-else :chartData="DEFAULT_CHART_DATA"></line-chart> -->
            </b-col>
            <hr>
            <!-- 아무 데이터 없을 경우에 대해 비어 있는 양식을 보여 줘야 함 -->
            <b-col sm="12" v-if="WebCastle_Daily_log_by_domain.length < 1">
              <h5><b>{{start}}.2.2.{{ WebCastle_Daily_log_by_server.length + 1 }} Daily Detecting & Blocking Domain</b></h5>
              <line-chart :chartData="DEFAULT_CHART_DATA"></line-chart>
            </b-col>
          </b-row>
          <hr>
          <!-- 서버별 -->
          <h5><b>{{start}}.2.3. Detecting and blocking Events per individual</b></h5>
          <b-row style="padding-left:25px;">
            <b-col>
              <h5 v-if="show_agent"><b>{{start}}.2.3.1. Total number and Risk info per server</b></h5>
              <div v-if="show_agent">
                <div style="width:100%;">
                  <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <thead>
                    <tr>
                      <th class="table-f1" style="max-width:250px;" rowspan="2">Server Name</th>
                      <th class="table-f1" style="width:180px;" colspan="2">Events</th>
                      <th class="table-f1" style="width:180px;" colspan="2">Risk</th>
                      <th class="table-f1" style="max-width:100px;" rowspan="2">
                        Diagram
                      </th>
                    </tr>
                    <tr style="min-height:200px;">
                      <th class="table-f1">Detected</th>
                      <th class="table-f1">Blocked</th>
                      <th class="table-f1">Level</th>
                      <th class="table-f1">Total</th>
                    </tr>
                  </thead>
                  <tbody v-for="server in WebCastle_total_info_by_server_2_2_3_1" :key="server.index" style="width:100%">
                    <tr v-for="(risk, sindex) in server.severity" v-bind:key="risk.index">
                      <td style="border:1px solid;" :rowspan="server.severity.length" v-if="server.severity.length ? sindex == 0 : false"> {{server.name}} </td>
                      <td style="border:1px solid;" :rowspan="server.severity.length" v-if="server.severity.length ? sindex == 0 : false"> {{server.detect | number}} </td>
                      <td style="border:1px solid;" :rowspan="server.severity.length" v-if="server.severity.length ? sindex == 0 : false"> {{server.block | number}} </td>
                      <td style="border:1px solid;"> {{codes.WAF_SEVERITY_TO_DESC(risk.Key)}} </td>
                      <td style="border:1px solid;"> {{risk.Value}} </td>
                      <td v-if="sindex == 0" style="border:1px solid; min-width:150px; max-width:300px; min-height:150px; height:150px;" rowspan="4">
                        <DoughnutChart v-if="server.severity.length > 0" :chartData="get_doughnut_data(server.severity)" :options="{ legend: { display: false }, responsive: true, maintainAspectRatio: true }" />
                      </td>
                    </tr>
                    <!-- <tr v-if="server.severity.length < 1">
                      <td style="border:1px solid;"> {{server.nickname}} </td>
                      <td style="border:1px solid;"> 0 </td>
                      <td style="border:1px solid;"> 0 </td>
                      <td style="border:1px solid;"> N/A </td>
                      <td style="border:1px solid;"> N/A </td>
                      <td style="border:1px solid;"> N/A </td>
                    </tr> -->
                  </tbody>
                  <tbody v-if="!WebCastle_total_info_by_server_2_2_3_1 || !WebCastle_total_info_by_server_2_2_3_1.length" style="width:100%">
                    <tr>
                      <td style="border:1px solid;"> N/A </td>
                      <td style="border:1px solid;"> 0 </td>
                      <td style="border:1px solid;"> 0 </td>
                      <td style="border:1px solid;"> N/A </td>
                      <td style="border:1px solid;"> N/A </td>
                      <td style="border:1px solid;"> N/A </td>
                    </tr>
                  </tbody>
                </table>
                </div>
              </div>
              <h5><b>{{start}}.2.3.{{ show_agent ? 2 : 1 }}. Total number and Risk info per domain</b></h5>
              <div>
                <div style="width:100%;">
                  <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <thead>
                    <tr>
                      <th class="table-f1" style="max-width:250px;" rowspan="2">Domain(Host)</th>
                      <th class="table-f1" style="width:180px;" colspan="2">Events</th>
                      <th class="table-f1" style="width:180px;" colspan="2">Risk</th>
                      <th class="table-f1" style="max-width:180px;" rowspan="2">
                        Diagram
                      </th>
                    </tr>
                    <tr style="min-height:200px;">
                      <th class="table-f1">Detected</th>
                      <th class="table-f1">Blocked</th>
                      <th class="table-f1">Level</th>
                      <th class="table-f1">Total</th>
                    </tr>
                  </thead>
                  <tbody v-for="server in WebCastle_total_info_by_server_2_2_3_2" :key="server.index" style="width:100%">
                    <tr v-for="(risk, sindex) in server.severity" v-bind:key="risk.index">
                      <td style="border:1px solid;" :rowspan="server.severity.length" v-if="server.severity.length ? sindex == 0 : false"> {{server.host}} </td>
                      <td style="border:1px solid;" :rowspan="server.severity.length" v-if="server.severity.length ? sindex == 0 : false"> {{server.detect | number}} </td>
                      <td style="border:1px solid;" :rowspan="server.severity.length" v-if="server.severity.length ? sindex == 0 : false"> {{server.block | number}} </td>
                      <td style="border:1px solid;"> {{codes.WAF_SEVERITY_TO_DESC(risk.Key)}} </td>
                      <td style="border:1px solid;"> {{risk.Value}} </td>
                      <td v-if="sindex == 0" style="border:1px solid; min-width:150px; max-width:300px; min-height:150px; height:150px;" rowspan="4">
                        <DoughnutChart v-if="server.severity.length > 0" :chartData="get_doughnut_data(server.severity)" :options="{ legend: { display: false }, responsive: true, maintainAspectRatio: true }" />
                      </td>
                    </tr>
                    <!-- <tr v-if="server.severity.length < 1">
                      <td style="border:1px solid;"> {{server.nickname}} </td>
                      <td style="border:1px solid;"> 0 </td>
                      <td style="border:1px solid;"> 0 </td>
                      <td style="border:1px solid;"> N/A </td>
                      <td style="border:1px solid;"> N/A </td>
                      <td style="border:1px solid;"> N/A </td>
                    </tr> -->
                  </tbody>
                  <tbody v-if="!WebCastle_total_info_by_server_2_2_3_2 || !WebCastle_total_info_by_server_2_2_3_2.length" style="width:100%">
                    <tr>
                      <td style="border:1px solid;"> N/A </td>
                      <td style="border:1px solid;"> 0 </td>
                      <td style="border:1px solid;"> 0 </td>
                      <td style="border:1px solid;"> N/A </td>
                      <td style="border:1px solid;"> N/A </td>
                      <td style="border:1px solid;"> N/A </td>
                    </tr>
                  </tbody>
                </table>
                </div>
              </div>

              <!-- <div v-if="WebCastle_total_info_by_server_2_2_3_1 && WebCastle_total_info_by_server_2_2_3_1.length < 1" style="width:100%">
                <div style="width:100%;">
                  <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr>
                      <td  class="table-f1" style="width:40%" rowspan="2">Server Name</td>
                      <td  class="table-f1" style="width:40%" colspan="2">Events</td>
                      <td  class="table-f1" style="width:40%" colspan="2">Risk</td>
                      <td  class="table-f1" style="width:40%" rowspan="2">
                        Diagram
                      </td>
                    </tr>
                    <tr style="min-height:200px;">
                      <td  class="table-f1">Detected</td>
                      <td  class="table-f1">Blocked</td>
                      <td  class="table-f1">Level</td>
                      <td  class="table-f1">Total</td>
                    </tr>
                    <tr>
                      <td style="border:1px solid;">N/A</td>
                      <td style="border:1px solid;">N/A</td>
                      <td style="border:1px solid;">N/A</td>
                      <td style="border:1px solid;">N/A</td>
                      <td style="border:1px solid;">N/A</td>
                      <td style="border:1px solid;">N/A</td>
                    </tr>
                  </tbody>
                </table>
                </div>
              </div> -->
            </b-col>

          </b-row>
          <h5><b>{{start}}.2.4. TOP 10 Events per individual</b></h5>
          <b-row style="padding-left:25px;">
            <b-col>

              <!-- server -->
              <h5 v-if="show_agent"><b>{{start}}.2.4.1. TOP 10 Events Server (Total)</b></h5>
              <table v-if="show_agent" style="word-break:break-all; width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px; table-layout:fixed">
                <tbody>
                  <tr>
                    <td class="table-f1" style="width:30px" rowspan="2">No.</td>
                    <th class="table-f1" style="width:120px;" rowspan="2">Attacker IP</th>
                    <th class="table-f1" style="width:120px;" rowspan="2">Domain(Host)</th>
                    <th class="table-f1" style="width:300px;" rowspan="2">Message</th>
                    <th class="table-f1" style="width:200px;" colspan="3">Details Events</th>
                  </tr>
                  <tr>
                    <th class="table-f1">Detected</th>
                    <th class="table-f1">Blocked</th>
                    <th class="table-f1">Risk</th>
                  </tr>
                  <tr v-if="!castle_summary.top_n_attack_from || (castle_summary.top_n_attack_from && castle_summary.top_n_attack_from.length < 1)">
                    <th style="border:1px solid; text-align: center;">N/A</th>
                    <th style="border:1px solid; text-align: center;">N/A</th>
                    <th style="border:1px solid; text-align: center;">N/A</th>
                    <th style="border:1px solid; text-align: center;">N/A</th>
                    <th style="border:1px solid; text-align: center;">N/A</th>
                    <th style="border:1px solid; text-align: center;">N/A</th>
                    <th style="border:1px solid; text-align: center;">N/A</th>
                  </tr>
                  <tr v-for="(WC_2_2_3_1, index) in castle_summary.top_n_attack_from" :key="index">
                    <th style="border:1px solid; text-align: center;">{{index + 1}}</th>
                    <th style="border:1px solid; text-align: center;">{{WC_2_2_3_1.remote_addr}}</th>
                    <th style="border:1px solid; text-align: center;">{{WC_2_2_3_1.target}}</th>
                    <th style="border:1px solid; text-align: center;">
                      {{webcastle_msg(WC_2_2_3_1.message)}}
                    </th>
                    <th style="border:1px solid; text-align: center;">{{WC_2_2_3_1.detect | number}}</th>
                    <th style="border:1px solid; text-align: center;">{{WC_2_2_3_1.block | number}}</th>
                    <th :style="`border:1px solid; text-align: center; font-weight:bold; font-size: 11px;`">
                        <span :style="`color:${hexToRgba(codes.WAF_SEVERITY_TO_COLOR(WC_2_2_3_1.severity))};`"> {{codes.WAF_SEVERITY_TO_DESC(WC_2_2_3_1.severity)}} </span>
                      </th>
                  </tr>
                </tbody>
              </table>
              <div v-for="(WC_2_2_3_3, index) in castle_summary.top_n_attack_agent" :key="index" v-if="show_agent">
                <h5><b>{{start}}.2.4.{{Number(index) + 1 + 1}}. TOP 10 Events per server ({{WC_2_2_3_3.name}}) </b></h5>
                <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr>
                      <td class="table-f1" style="width:30px" rowspan="2">No.</td>
                      <th class="table-f1" style="width:120px;" rowspan="2">Attacker IP</th>
                      <!-- <th class="table-f1" style="width:80px;" rowspan="2">Victim</th> -->
                      <th class="table-f1" style="width:400px;" rowspan="2">Message</th>
                      <th class="table-f1" style="width:170px;" colspan="3">Details Events</th>
                    </tr>
                    <tr>
                      <th class="table-f1">Detected</th>
                      <th class="table-f1">Blocked</th>
                      <th class="table-f1">Risk</th>
                    </tr>
                    <tr v-if="(WC_2_2_3_3.data && WC_2_2_3_3.data.length < 1) || WC_2_2_3_3.data == ''">
                      <th style="border:1px solid; text-align: center;">-</th>
                      <th style="border:1px solid; text-align: center;">N/A</th>
                      <!-- <th style="border:1px solid; text-align: center;">N/A</th> -->
                      <th style="border:1px solid; text-align: center;">N/A</th>
                      <th style="border:1px solid; text-align: center;">N/A</th>
                      <th style="border:1px solid; text-align: center;">N/A</th>
                      <th style="border:1px solid; text-align: center;">N/A</th>
                    </tr>
                    <tr v-for="(WC_2_2_3_3_2, sindex) in WC_2_2_3_3.data" :key="sindex">
                      <th style="border:1px solid; text-align: center;">{{sindex + 1}}</th>
                      <th style="border:1px solid; text-align: center;">{{WC_2_2_3_3_2.remote_addr}}</th>
                      <!-- <th style="border:1px solid; text-align: center;">{{WC_2_2_3_3_2.target}}</th> -->

                      <th style="border:1px solid; text-align: center;">
                        {{webcastle_msg(WC_2_2_3_3_2.message)}}
                      </th>
                      <th style="border:1px solid; text-align: center;">{{WC_2_2_3_3_2.detect | number}}</th>
                      <th style="border:1px solid; text-align: center;">{{WC_2_2_3_3_2.block | number}}</th>
                      <th :style="`border:1px solid; text-align: center; font-weight:bold; font-size: 11px;`" class="">
                        <span :style="`color:${hexToRgba(codes.WAF_SEVERITY_TO_COLOR(WC_2_2_3_3_2.severity))};`">
                          {{codes.WAF_SEVERITY_TO_DESC(Number(WC_2_2_3_3_2.severity))}}
                        </span>
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-row>
          <!-- <h5><b>{{start}}.2.4. Detecting and blocking Events per domain</b></h5> -->
          <b-row style="padding-left:25px;">
            <b-col>
              <!-- <h5><b>{{start}}.2.4.1. Total number and Risk info per domain</b></h5>
              <div>
                <div style="width:100%;">
                  <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <thead>
                    <tr>
                      <th class="table-f1" style="max-width:250px;" rowspan="2">Server Name</th>
                      <th class="table-f1" style="width:180px;" colspan="2">Events</th>
                      <th class="table-f1" style="width:180;" colspan="2">Risk</th>
                      <th class="table-f1" style="width:40%" rowspan="2">
                        Diagram
                      </th>
                    </tr>
                    <tr style="min-height:200px;">
                      <th class="table-f1">Detected</th>
                      <th class="table-f1">Blocked</th>
                      <th class="table-f1">Level</th>
                      <th class="table-f1">Total</th>
                    </tr>
                  </thead>
                  <tbody v-for="server in WebCastle_total_info_by_server_2_2_3_1" :key="server.index" style="width:100%">
                    <tr v-for="(risk, sindex) in server.severity" v-bind:key="risk.index">
                      <td style="border:1px solid;" :rowspan="server.severity.length" v-if="server.severity.length ? sindex == 0 : false"> {{server.nickname}} </td>
                      <td style="border:1px solid;" :rowspan="server.severity.length" v-if="server.severity.length ? sindex == 0 : false"> {{server.dt_total}} </td>
                      <td style="border:1px solid;" :rowspan="server.severity.length" v-if="server.severity.length ? sindex == 0 : false"> {{server.bk_total}} </td>
                      <td style="border:1px solid;"> {{codes.WAF_SEVERITY_TO_DESC(risk.severity)}} </td>
                      <td style="border:1px solid;"> {{risk.total}} </td>
                      <td v-if="sindex == 0" style="border:1px solid;" rowspan="4">
                        <DoughnutChart v-if="server.severity.length > 0" :chartData="get_doughnut_data(server.severity)" :options="{ legend: { display: true }, responsive: true, maintainAspectRatio: true }" />
                      </td>
                    </tr>
                    <tr v-if="server.severity.length < 1">
                      <td style="border:1px solid;"> {{server.nickname}} </td>
                      <td style="border:1px solid;"> 0 </td>
                      <td style="border:1px solid;"> 0 </td>
                      <td style="border:1px solid;"> N/A </td>
                      <td style="border:1px solid;"> N/A </td>
                      <td style="border:1px solid;"> N/A </td>
                    </tr>
                  </tbody>
                  <tbody v-if="WebCastle_total_info_by_server_2_2_3_1.length < 1" style="width:100%">
                    <tr>
                      <td style="border:1px solid;"> N/A </td>
                      <td style="border:1px solid;"> 0 </td>
                      <td style="border:1px solid;"> 0 </td>
                      <td style="border:1px solid;"> N/A </td>
                      <td style="border:1px solid;"> N/A </td>
                      <td style="border:1px solid;"> N/A </td>
                    </tr>
                  </tbody>
                </table>
                </div>
              </div> -->
              <!-- <div v-if="WebCastle_total_info_by_server_2_2_3_1 && WebCastle_total_info_by_server_2_2_3_1.length < 1" style="width:100%">
                <div style="width:100%;">
                  <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr>
                      <td class="table-f1" style="width:40%" rowspan="2">Server Name</td>
                      <td class="table-f1" style="width:40%" colspan="2">Events</td>
                      <td class="table-f1" style="width:40%" colspan="2">Risk</td>
                      <td class="table-f1" style="width:40%" rowspan="2">
                        Diagram
                      </td>
                    </tr>
                    <tr style="min-height:200px;">
                      <td class="table-f1">Detected</td>
                      <td class="table-f1">Blocked</td>
                      <td class="table-f1">Level</td>
                      <td class="table-f1">Total</td>
                    </tr>
                    <tr>
                      <td style="border:1px solid;">N/A</td>
                      <td style="border:1px solid;">N/A</td>
                      <td style="border:1px solid;">N/A</td>
                      <td style="border:1px solid;">N/A</td>
                      <td style="border:1px solid;">N/A</td>
                      <td style="border:1px solid;">N/A</td>
                    </tr>
                  </tbody>
                </table>
                </div>
              </div> -->

              <h5><b>{{start}}.2.4.{{ castle_summary.top_n_attack_agent ? castle_summary.top_n_attack_agent.length + (show_agent ? 2 : 0) : (show_agent ? 2 : 1) }}. TOP 10 Events Domain(Host) Total</b></h5>
              <table style="word-break:break-all; width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px; table-layout:fixed">
                <tbody>
                  <tr>
                    <td class="table-f1" style="width:30px" rowspan="2">No.</td>
                    <th class="table-f1" style="width:80px;" rowspan="2">Attacker IP</th>
                    <th class="table-f1" style="width:80px;" rowspan="2">Domain <br> (Host)</th>
                    <th class="table-f1" style="width:360px;" rowspan="2">Message</th>
                    <th class="table-f1" style="width:200px;" colspan="3">Details Events</th>
                  </tr>
                  <tr>
                    <th class="table-f1">Detected</th>
                    <th class="table-f1">Blocked</th>
                    <th class="table-f1">Risk</th>
                  </tr>
                  <tr v-if="castle_summary && castle_summary.top_n_attack_from && castle_summary.top_n_attack_from.length < 1">
                    <th style="border:1px solid; text-align: center;">N/A</th>
                    <th style="border:1px solid; text-align: center;">N/A</th>
                    <th style="border:1px solid; text-align: center;">N/A</th>
                    <th style="border:1px solid; text-align: center;">N/A</th>
                    <th style="border:1px solid; text-align: center;">N/A</th>
                    <th style="border:1px solid; text-align: center;">N/A</th>
                    <th style="border:1px solid; text-align: center;">N/A</th>
                  </tr>
                  <tr v-for="(WC_2_2_3_1, index) in castle_summary.top_n_attack_from" :key="index">
                    <th style="border:1px solid; text-align: center;">{{index + 1}}</th>
                    <th style="border:1px solid; text-align: center;">{{WC_2_2_3_1.remote_addr}}</th>
                    <th style="border:1px solid; text-align: center;">{{WC_2_2_3_1.target}}</th>
                    <th style="border:1px solid; text-align: center;">
                      {{webcastle_msg(WC_2_2_3_1.message)}}
                    </th>
                    <th style="border:1px solid; text-align: center;">{{WC_2_2_3_1.detect | number}}</th>
                    <th style="border:1px solid; text-align: center;">{{WC_2_2_3_1.block | number}}</th>
                    <th :style="`border:1px solid; text-align: center; font-weight:bold; font-size: 11px;`">
                      <span :style="`color:${hexToRgba(codes.WAF_SEVERITY_TO_COLOR(WC_2_2_3_1.severity))};`"> {{codes.WAF_SEVERITY_TO_DESC(WC_2_2_3_1.severity)}} </span>
                    </th>
                  </tr>
                </tbody>
              </table>
              <div v-for="(WC_2_2_3_4, index) in castle_summary.top_n_attack_domain" :key="index">
                <h5><b>{{start}}.2.4.{{Number(index) + (castle_summary.top_n_attack_agent ? castle_summary.top_n_attack_agent.length + (show_agent ? 3 : 1) : (show_agent ? 3 : 2))}}. TOP 10 Events per domain ({{ WC_2_2_3_4.name }}) <small class="float-right">List of last 10</small> </b></h5>
                <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr>
                      <td class="table-f1" style="width:30px" rowspan="2">No.</td>
                      <th class="table-f1" style="width:80px;" rowspan="2">Attacker IP</th>
                      <th class="table-f1" style="width:400px;" rowspan="2">Message</th>
                      <th class="table-f1" style="width:170px;" colspan="3">Details Events</th>
                    </tr>
                    <tr>
                      <th class="table-f1">Detected</th>
                      <th class="table-f1">Blocked</th>
                      <th class="table-f1">Risk</th>
                    </tr>
                    <tr v-if="(WC_2_2_3_4.data && WC_2_2_3_4.data.length < 1) || WC_2_2_3_4.data == ''">
                      <th style="border:1px solid; text-align: center;">-</th>
                      <th style="border:1px solid; text-align: center;">N/A</th>
                      <th style="border:1px solid; text-align: center;">N/A</th>
                      <th style="border:1px solid; text-align: center;">N/A</th>
                      <th style="border:1px solid; text-align: center;">N/A</th>
                      <th style="border:1px solid; text-align: center;">N/A</th>
                    </tr>
                    <tr v-for="(WC_2_2_3_4_2, sindex) in WC_2_2_3_4.data" :key="sindex">
                      <th style="border:1px solid; text-align: center;">{{sindex + 1}}</th>
                      <th style="border:1px solid; text-align: center;">{{WC_2_2_3_4_2.remote_addr}}</th>
                      <th style="border:1px solid; text-align: center;">
                        {{webcastle_msg(WC_2_2_3_4_2.message)}}
                      </th>
                      <th style="border:1px solid; text-align: center;">{{WC_2_2_3_4_2.detect | number}}</th>
                      <th style="border:1px solid; text-align: center;">{{WC_2_2_3_4_2.block | number}}</th>
                      <th :style="`border:1px solid; text-align: center; font-weight:bold; font-size: 11px;`" class="">
                        <span :style="`color:${hexToRgba(codes.WAF_SEVERITY_TO_COLOR(WC_2_2_3_4_2.severity))};`">
                          {{codes.WAF_SEVERITY_TO_DESC(WC_2_2_3_4_2.severity)}}
                        </span>
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- 데이터가 없다면 -->
              <div v-if="castle_summary.top_n_attack_domain < 1">
                <h5><b>{{start}}.2.4.{{1}} TOP 10 Events per domain (-) <small class="float-right">List of last 10</small> </b></h5>
                <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr>
                      <td class="table-f1" style="width:30px" rowspan="2">No.</td>
                      <th class="table-f1" style="width:80px;" rowspan="2">Attacker IP</th>
                      <th class="table-f1" style="width:400px;" rowspan="2">Message</th>
                      <th class="table-f1" style="width:170px;" colspan="3">Details Events</th>
                    </tr>
                    <tr>
                      <th class="table-f1">Detected</th>
                      <th class="table-f1">Blocked</th>
                      <th class="table-f1">Risk</th>
                    </tr>
                    <tr>
                      <th style="border:1px solid; text-align: center;">-</th>
                      <th style="border:1px solid; text-align: center;">N/A</th>
                      <th style="border:1px solid; text-align: center;">N/A</th>
                      <th style="border:1px solid; text-align: center;">N/A</th>
                      <th style="border:1px solid; text-align: center;">N/A</th>
                      <th style="border:1px solid; text-align: center;">N/A</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-row>
          </b-col>
        </b-row>
        <hr>
        <h4><b>{{start}}.3 Attack Trend </b></h4>
        <b-row style="padding-left:25px;">
          <b-col>
            <h5><b>{{start}}.3.1. Daily Attack analysis by Risk</b></h5>
            <b-row style="padding-left:25px;">
              <b-col>
                <bar-chart :chartData="WebCastle_attack_trend_total_2_3"></bar-chart>
                <hr>
                <!-- // TODO : 이 부분은 나중에 메일 발송 기능 완벽하면 추가되어야 함 -->
                <!-- <h5><b>{{start}}.3.1.1. Alert sending status</b></h5>
                <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr>
                      <th class="table-f1" style="width:40%"></th>
                      <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Detection E-mail</th>
                      <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Blocking E-mail</th>
                    </tr>
                    <tr>
                      <th class="border-bg-f1">Alert</th>
                      <th class="border-bg-f1">{{60}}</th>
                      <th class="border-bg-f1">{{5}}</th>
                    </tr>
                  </tbody>
                </table>
                <h5><b>{{start}}.3.1.2. Daily detection Alert</b></h5>
                <line-chart :chartData="this.chartData"></line-chart>
                <h5><b>{{start}}.3.1.3. Daily blocking Alert</b></h5>
                <line-chart :chartData="this.chartData"></line-chart> -->
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!-- <h4><b>{{start}}.4 Management Status</b></h4>
        <b-row style="padding-left:25px;">
          <b-col>
            <h5><b>{{start}}.4.1. Attack detection pattern</b></h5>
            <b-row style="padding-left:25px;">
              <b-col>
                <h5><b>{{start}}.4.1.1. Number or update</b></h5>
                <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr>
                      <th style="width:40%"></th>
                      <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Total</th>
                      <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Updated</th>
                    </tr>
                    <tr>
                      <th class="border-bg-f1">Pattern</th>
                      <th class="border-bg-f1">{{`150,000`}}</th>
                      <th class="border-bg-f1">{{15}}</th>
                    </tr>
                  </tbody>
                </table>
                <h5><b>{{start}}.4.1.2. Daily update</b></h5>
                <line-chart :chartData="this.chartData"></line-chart>
                <h5><b>{{start}}.4.1.3. Updated pattern description</b></h5>
                <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr>
                      <th class="table-f1">Date</th>
                      <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Name</th>
                      <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Summary</th>
                    </tr>
                    <tr>
                      <th class="border-bg-f1">{{`YYYY.mm.dd`}}</th>
                      <th class="border-bg-f1">{{`MongoDB SQL Injection`}}</th>
                      <th class="border-bg-f1">{{`Detect MongoDB Target SQL Injection Attacks`}}</th>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-col>
        </b-row> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>

// chart
import lineChart from '../../chart/MainChart';
import BarChart from '../../chart/BarChart';
import DoughnutChart from '../../chart/DoughnutChart';
import StackedVerticalBarChart from '../../chart/StackedVerticalBarChart'
import { hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities';

// lib
import auth from '@/f1/service/auth';
import codes from '@/f1/codes';
import _ from 'lodash'
import Custom from '@/f1/service/custom';
import moment from 'moment-timezone';

export default {
  name:'ReportWebCastle',
  props: [
    'start',
    'end',
    'from',
    'to',
    'castle_agent',
    'castle_summary',
    'WebCastle_attack_trend_total_2_3',
    'WebCastle_total_info_by_server_2_2_3_1',
    'WebCastle_total_info_by_server_2_2_3_2',
    'WebCastle_Daily_log_by_server',
    'WebCastle_Daily_log_by_domain',
    'WebCastle_Daily_Detecting',
    'WebCastle_Daily_Blocking',
    'show_agent',
    'show_domain'
  ],
  components: {
    // chart
    lineChart,
    DoughnutChart,
    BarChart,
    StackedVerticalBarChart,

  },
  data: () => {
    return {
      moment,
      custom : Custom.custom_default,
      // util
      hexToRgba,
      codes,
      auth,
      DEFAULT_CHART_DATA : {
        labels: [],
        datasets: [
          {
            label: 'No have value',
            backgroundColor: '#f87979',
            data: []
          }
        ]
      }
    }
  },
  computed: {
  },
  methods: {
    // custom
    webcastle_msg(x) {
      try { return JSON.parse(x).messages ? this.ruleI18n[JSON.parse(x).messages[0].details.ruleId]['KO'] : JSON.parse(x).message }
      catch (error) { return JSON.parse(x).messages[0].message }
    },
    get_doughnut_data: function(severity) {
      let doughnut_data = { labels: [], datasets: [ { label: 'Risk analysis', backgroundColor: [], data: [] } ] }
      _.sortBy(severity, s => s.Value).forEach(x => {
        doughnut_data.labels.push(codes.WAF_SEVERITY_TO_DESC(x.Key))
        doughnut_data.datasets[0].data.push(x.Value)
        doughnut_data.datasets[0].backgroundColor.push(codes.WAF_SEVERITY_TO_COLOR(Number(x.Key)))
      })
      return doughnut_data
    },
    // 넘버링
  },
  created: function() {
    console.log(`[${this.custom.slogan}$]Report.webcastle.vue`, `created`);
  },
  destroyed: function() { console.log(`[${this.custom.slogan}$]Report.webcastle.vue`, `destroyed`); },
  mounted: function() {
    this.custom = Custom.setting()
    console.log(`[${this.custom.slogan}$]Report.webcastle.vue`, `mounted`);
  },
}
</script>
